import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './SearchBar.css';
import searchIcon from '../../assets/images/search-icon.svg';

const SearchBar = () => {
  const [query, setQuery] = useState('');
  const [placeholder, setPlaceholder] = useState("Search by title, author, isbn, genre...");

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleButtonClick = () => {
    navigate(`/search/${query}`);
  };

  // Update placeholder based on screen size
  useEffect(() => {
    const updatePlaceholder = () => {
      if (window.innerWidth <= 500) {
        setPlaceholder("Search...");
      } else {
        setPlaceholder("Search by title, author, isbn, genre...");
      }
    };

    // Call on component mount
    updatePlaceholder();

    // Add resize event listener
    window.addEventListener("resize", updatePlaceholder);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updatePlaceholder);
  }, []);

  return (
    <div className="search-bar">
      <form onSubmit={(e) => {e.preventDefault(); handleButtonClick();}} >
        <input
          type="text"
          placeholder={placeholder}
          value={query}
          onChange={handleInputChange}
          className="search-input"
        />
        <button type="submit" className="search-button">
          <img src={searchIcon} alt="Search" className='search-icon'/>
        </button>
      </form>
    </div>
  );
};

export default SearchBar;
